import React, { useEffect } from 'react'
import { get, map, isEmpty, filter, includes, size } from 'lodash';
import { object } from 'prop-types';
import { withFirebase } from '../../../hoc';
import { success } from './notificationTypes';
import { showNotification, styleNotification } from './notificationConfig';
import { NotificationContent } from './NotificationContent';
import { reactivateAlertSoundNotification } from './reactivateAlertSoundNotification';
import alertSound from '../../../../assets/sounds/alert_sound.mp3';
import useFirebaseStoresListener from '../../hooks/useFirebaseStoresListener';
import useCollectionListener from '../../hooks/useCollectionListener';

const { backgroundColor, borderColor } = success

export const playSoundAlert = () => {
    const audio = new Audio(alertSound)
    audio.play().catch((_) => reactivateAlertSoundNotification());
};

const NewOrdersNotification = ({ session, firebase }) => {
    if (isEmpty(firebase)) return null
    const storeSpid = filter(get(session, 'salesChannels', []), ({ kind }) => kind === 'SPID35');
    const storeIds = map(storeSpid, 'id')
    const { storesWithSoundPermission, storesWithNotificationPermission, loading: loadingFirebaseStoresListener } = useFirebaseStoresListener(firebase, storeIds)
    const { order, storeId, cleanOrder } = useCollectionListener(firebase, storeIds);
    const soundEnabled = JSON.parse(localStorage.getItem('soundEnabled'));
    const isBrowserTabActive = !document.hidden

    useEffect(() => {
        if (isEmpty(order) || loadingFirebaseStoresListener) return;

        if (!includes(storesWithNotificationPermission, storeId)) {
            cleanOrder();
            return;
        }

        if (includes(storesWithSoundPermission, storeId) && isBrowserTabActive && (soundEnabled === null || soundEnabled)) {
            playSoundAlert();
        }
        
        showNotification({
            message: <NotificationContent orderId={get(order, 'idOrder')} />,
            style: {
                ...styleNotification,
                backgroundColor,
                border: `1px solid ${borderColor}`,
                height: 94,
                width: 500,
                marginLeft: 384 - 500,
            },
        }, cleanOrder);
        
    }, [order]);

    return null
};

NewOrdersNotification.propTypes = {
    firebase: object,
    session: object
};

export default withFirebase(NewOrdersNotification)